import { LocaleModule } from "@/core/modules/locale/objects/LocaleModule";

import { en } from "./en";
import { it } from "./it";

export const branchLegalRecordLocaleModule: LocaleModule = {
  name: "branchLegalRecord",
  messages: { en: en, it: it },
};
